import _regeneratorRuntime from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _defineProperty from "C:\\Executables\\Raindeers\\ClaimsHub\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { JSON_CONTENT_TYPE, CONTENT_TYPE } from '../common';
export function defaultErrorResponseHandler(response) {
  var message, error, contentType;
  return _regeneratorRuntime.async(function defaultErrorResponseHandler$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          error = {
            status: response.status,
            statusText: response.statusText || '<none>'
          };
          contentType = response.headers.get(CONTENT_TYPE);

          if (!contentType) {
            _context.next = 13;
            break;
          }

          if (!_includesInstanceProperty(contentType).call(contentType, JSON_CONTENT_TYPE)) {
            _context.next = 9;
            break;
          }

          _context.next = 6;
          return _regeneratorRuntime.awrap(response.json());

        case 6:
          message = _context.sent;
          _context.next = 13;
          break;

        case 9:
          _context.next = 11;
          return _regeneratorRuntime.awrap(response.text());

        case 11:
          _context.t0 = _context.sent;
          message = {
            message: _context.t0
          };

        case 13:
          return _context.abrupt("return", _Promise.reject(_objectSpread({}, error, {}, message)));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, null, null, null, Promise);
}